import "./mainLayout.css"

import React from "react";

import Header from "./components/Header";
import Footer from "./components/Footer";

const MainLayout = ({children}) => {
    return (
        <div className="app-layout">
            <Header/>
            <main className="app-main">
                {children}
            </main>
            <Footer/>
        </div>
    )
}

export default MainLayout